// extracted by mini-css-extract-plugin
export default {"warn-icon":"mAZF70It--ValidationError_warn-icon__6MWw0","warnIcon":"mAZF70It--ValidationError_warn-icon__6MWw0"};